import { useState, useEffect } from 'react';
import axios from '../../api/api';
import swal from 'sweetalert';
import Cookie from 'js-cookie';

export default function AuthToken () {
  function getToken () {
    const tokenString = window.localStorage.getItem('token');
    const userToken = JSON.parse(tokenString);

    // Check if the token exists and is not expired
    if (userToken && userToken.expiresAt > new Date().getTime()) {
      axios.defaults.headers.common.Authorization = `Bearer ${userToken.data.authorisation.token}`;
      axios.defaults.headers.common['Content-Type'] = 'application/json';
      return userToken?.data.authorisation.token;
    } else {
      // Remove the token if it is expired or not present
      window.localStorage.removeItem('token');
      return null;
    }
  }

  const [accessToken, setAccessToken] = useState(getToken());

  const saveToken = (userToken, expirationHours = 3) => {
    const expiresAt = new Date().getTime() + expirationHours * 60 * 60 * 1000;
    const tokenData = { data: userToken.data, expiresAt };
    Cookie.set('token', userToken.data, { expires: 30 });

    window.localStorage.setItem('token', JSON.stringify(tokenData));
    setAccessToken(userToken);
  };

  useEffect(() => {
    // Check and remove expired token on component mount
    getToken();

    // Set up an interval to check token expiration every minute
    const checkTokenInterval = setInterval(() => {
      const token = getToken();
      if (!token) {
        clearInterval(checkTokenInterval); // Stop checking once token is expired
        const handleSessionExpired = async () => {
          await swal('Session has expired!', 'Please log in again.', 'info');
          window.location.href = '/';
          window.location.reload();
        };
        handleSessionExpired();
      }
    }, 1 * 60 * 60 * 1000); // Check every 1 hour

    return () => clearInterval(checkTokenInterval);
  }, []);

  return {
    setAccessToken: saveToken,
    accessToken
  };
}
